"use client";

import { CALL_TIMES } from "@/features/leads/shared/list-answers";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { toggled } from "@/shared/lib/list";

export function CallTimeStep() {
  const { next, back, canAdvance } = useWizard();
  const [{ callTimes = [] }, answer] = useStep("callTime");

  return (
    <section>
      <StepHeading
        title="Hvornår kan du bedst tage telefonen?"
        body="Firmaet ringer dig med et uforpligtende tilbud. Vælg et eller flere tidsrum, så ringer de, når du kan svare."
        maxW="max-w-[24ch]"
      />
      <CheckRow
        options={CALL_TIMES.options}
        values={callTimes}
        onToggle={(v) => answer({ callTimes: toggled(callTimes, v) })}
      />
      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
